._searchButton_1uszz_1 {
  display: inline-flex;
  align-items: center;
  height: 30px;
  padding: 9px 12px 6px;
  color: #ffffff;
  background-color: transparent;
  box-sizing: content-box;
  border: none;
  cursor: pointer; }

._searchButton_1uszz_1 ._searchLabel_1uszz_12 {
  max-width: 90px;
  color: #ffffff;
  cursor: pointer; }

._searchButton_1uszz_1 ._searchBubble_1uszz_17 {
  display: none;
  position: relative;
  width: 0;
  height: 0;
  z-index: 99999;
  top: -21px;
  left: 22px; }

._searchButton_1uszz_1 ._searchBubble_1uszz_17 .bubble-content {
  flex-direction: column;
  align-items: unset;
  width: 240px;
  white-space: normal; }

._searchButton_1uszz_1:hover {
  text-decoration: underline; }

._searchButton_1uszz_1:hover ._searchBubble_1uszz_17 {
  display: block; }

._searchButton_1uszz_1 svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  margin-right: 4px; }

._searchButton_1uszz_1 svg > path {
  fill: #ffffff; }

._searchSeparator_1uszz_47 {
  background: #d9e1e8;
  border: none;
  width: calc(100% - 43px);
  height: 1px;
  margin: 0 18px;
  opacity: 0.5; }
